import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';

import cView from './cView';

import i14v1a from './i14v1a';

export default class iStg1 extends cView { // 団体用 home

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.d_viewDefs = {
//      name: 'その他'
      name: '基本設定'
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

$clp_loadLists = () => [ // 親を上書き
/*
  i14v1a.op_loadDtl({
    elm: 'i14r',
    fst: global.t?.state.sgcd_cmnStgs?.c20r_fst,
    op_atrAll: () => new Promise( _o_end1 => {
      let _d_i14rs = global.t?.state.sdld_i14rDtlsss.i14r[0];
      global.t?.setState({
        s_rsv1: _d_i14rs.d_flds.i14ri71s, // 設定説明文1
        s_rsv2: _d_i14rs.d_flds.i14ri81s, // 設定説明文2
        s_acn1: _d_i14rs.d_flds.i14ri72s, // 設定説明文1
        s_acn2: _d_i14rs.d_flds.i14ri82s, // 設定説明文2
        s_stg1: _d_i14rs.d_flds.i14ri73s, // 設定説明文1
      }, () => {
        _o_end1();
      })
    }),
  })
*/
];

  render() {

    let _l = [];
    Object.keys(global.t?.state.sgcdd_menuDefss ?? {})
    .filter( _pageName => (global.t?.state.sgcdd_menuDefss[_pageName].c40rt11i == 20) ? true : false ) // 副機能が対象
    .map( ( _pageName, _idx) => {
      _l.push(
        ce.c(ce.Box, {
          key: _idx,
          stlCta: {
            height: ic.s(7) * 2,
            width: ic.gn_maxBdyW / 3,
            flexDirection: 'column',
            justifyContent: 'space-around',
            alignItems: 'center',
          }
        }, [

          ce.c(ce.Msg, {
            key: -1,
            pfx: '',
            stlCta: {
              height: ic.s(1) * 2,
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            },
            stlPfx: {
              textAlign: 'center',
            },
          }),

          ce.c(ce.Btn, {
            key: -2,
            b_vsb: true,
            b_rvs: false,
            pfx: global.t?.state.sgcdd_menuDefss[_pageName].c40rc31s,
            o_onPrs: () => {
              let _d_pageInfs = {
                sgc_pageRole: global.t?.state.sgc_pageRole,
                sgc_pageName: _pageName,
                sgc_pageMode: 'show',
              };
              cf.myRN_move_fwd(_d_pageInfs);
            },
            stlCta: {
              height: ic.s(3) * 2,
            },
            stlBtn: {
              width: ic.gn_btnWLrg * 2,
              backgroundColor: ic.o_getCcd('p'),
            },
            stlPfx: {
              lineHeight: ic.s(3) * 2,
              fontSize: ic.s(1.2),
            },
          }),

          ce.c(ce.Msg, {
            key: -3,
            pfx: '',
            stlCta: {
              height: ic.s(3) * 2,
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            },
            stlPfx: {
              textAlign: 'center',
            },
          }),
        
        ]),
      );
    });

    return (
      ce.c(ce.RootDtl, {
        key: -1,
        d_hdrs: {
          d_subs: 
            ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) == false ?
              {
                iconName: 'users',
                pfx: 'ユーザ切替',
                o_onPrs: () => {
                  let _d_pageInfs = {
                    sgc_pageRole: global.t?.state.sgc_pageRole,
                    sgc_pageName: 'c00v2a',
                    sgc_pageMode: 'show',
                  };
                  cf.myRN_move_fwd(_d_pageInfs);
                },
              }
            : null,
        },
        d_bdys: {
          stlCta: {
            height: ic.gn_bdyH,
            flexDirection: 'column',
            justifyContent: 'center',
//            justifyContent: 'flex-start',
            alignItems: 'center',
          },
          l_clds: [


            ce.c(ce.Msg, {
              key: -10,
              pfx: '■各種設定の途中変更は、すでに設定済の団体のものにも適用されますのでご注意ください。',
              stlCta: {
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: ic.s(3),
              },
              stlPfx: {
                textAlign: 'center',
              },
            }),

            ce.c(ce.Box, {
              key: -20,
              stlCta: {
                width: global.t?.state.sgcd_dmns.n_bdyW,
                flexDirection: 'row',
//                justifyContent: 'space-around',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexWrap: 'wrap',
              }
            }, _l),

          ]
        }
      })
    );
  };
};


